/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PatientTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PatientTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PatientTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#0E5814"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PatientTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Zm042b': alignSelf,'--mt-2-Zm042b': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zm042b': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zm042b': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zm042b': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zm042b': opacity,'--w-10-Zm042b': typeof width === 'number' ? `${width}px` : width,'--h-11-Zm042b': typeof height === 'number' ? `${height}px` : height,'--f-12-Zm042b': fill,'--a-7-Zm042b': isAnimated ? animation : "none",'--sd-8-Zm042b': isAnimated ? strokeDashoffset : 0,'--sd-9-Zm042b': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PatientTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M15.801 16.057a7.074 7.074 0 00-13.602 0c.033.01.068.014.105.014h13.392a.371.371 0 00.105-.014zM2.304 0A2.304 2.304 0 000 2.304v13.392A2.304 2.304 0 002.304 18h13.392A2.304 2.304 0 0018 15.696V2.304A2.304 2.304 0 0015.696 0H2.304zM9 9.643a3.214 3.214 0 100-6.429 3.214 3.214 0 000 6.429z"
 style={{'--f-12-Zm042b': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}